module.exports = __webpack_public_path__ + "1.5.0-unryo/img/microsoft-azure.ab957f50.svg";